module.exports = __webpack_public_path__ + "img/impulso@x1.e2b2cb73.png";